import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invoice-load-start",
  "use": "icon-invoice-load-start-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-invoice-load-start\"><g clip-path=\"url(#icon-invoice-load-start_a)\"><circle cx=\"4\" cy=\"4\" r=\"3.5\" fill=\"#fff\" stroke=\"#7F8596\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><circle cx=\"4\" cy=\"4\" r=\"1.5\" fill=\"#7F8596\" /></g><defs><clipPath id=\"icon-invoice-load-start_a\"><path fill=\"#fff\" d=\"M0 0h8v8H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol